(() => {
  if (customElements.get('np-rich-photo-viewer')) return;
  customElements.define('np-rich-photo-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const dialog = this.querySelector('dialog');
      const sources = [...document.querySelectorAll('.np-gallery-dock [data-np-photo-src]')];
      if (!dialog || !sources.length) return;
      const photo = dialog.querySelector('[data-np-photo-full]');
      const count = dialog.querySelector('[data-np-photo-count]');
      const note = dialog.querySelector('[data-np-photo-note-text]');
      const choices = [...dialog.querySelectorAll('[data-np-photo-choose]')];
      let index = 0;
      const show = nextIndex => {
        index = (nextIndex + sources.length) % sources.length;
        photo.src = sources[index].dataset.npPhotoSrc;
        photo.alt = sources[index].dataset.npPhotoAlt;
        if (note) note.textContent = sources[index].dataset.npPhotoNote || 'Product image · example design';
        count.textContent = `${index + 1} / ${sources.length}`;
        choices.forEach((button, itemIndex) => button.setAttribute('aria-pressed', String(itemIndex === index)));
      };
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-np-photo-index]');
        if (!link || !dialog.isConnected || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        show(Number(link.dataset.npPhotoIndex) || 0);
        if (!dialog.open) dialog.showModal();
      });
      dialog.querySelector('[data-np-photo-close]').addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-np-photo-prev]').addEventListener('click', () => show(index - 1));
      dialog.querySelector('[data-np-photo-next]').addEventListener('click', () => show(index + 1));
      if (sources.length === 1) {
        dialog.querySelector('[data-np-photo-prev]').disabled = true;
        dialog.querySelector('[data-np-photo-next]').disabled = true;
      }
      choices.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.npPhotoChoose))));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
  });
})();
